import { Col, Row } from "react-bootstrap"
import { statNumberToString } from "../../../../apis/transform/stats"
import style from "./style.module.scss"
import cx from "classnames"

export function PlayerOpportunity({
  opportunity,
  failedOpportunity,
}: {
  opportunity: number
  failedOpportunity: number
}) {
  return (
    <div className={style.playerOpportunityContainer}>
      <Row className={cx(style.playerOpportunityRow, style.whiteBg)}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <dt>Occasioni create</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{statNumberToString(opportunity)}</dd>
          </Col>
        </dl>
      </Row>
      <Row className={style.playerOpportunityRow}>
        <dl>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.label}>
            <dt>Occasioni sbagliate</dt>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6} className={style.value}>
            <dd>{statNumberToString(failedOpportunity)}</dd>
          </Col>
        </dl>
      </Row>
    </div>
    // <Col className={"colStats"}>
    //   <Row>
    //     <Col sm={6} className={"centerColumn"}>
    //       <Row>
    //         <Col className={"competitionSeasonValueLarge"}>{statNumberToString(opportunity)}</Col>
    //       </Row>
    //       <Row>
    //         <Col className={"competitionSeasonLabel"}>
    //           <h2>Occasioni create</h2>
    //         </Col>
    //       </Row>
    //     </Col>
    //     <Col sm={6} className={"centerColumn leftBorder"}>
    //       <Row>
    //         <Col className={"competitionSeasonValueLarge"}>{statNumberToString(failedOpportunity)}</Col>
    //       </Row>
    //       <Row>
    //         <Col className={"competitionSeasonLabel"}>
    //           <h2>Occasioni sbagliate</h2>
    //         </Col>
    //       </Row>
    //     </Col>
    //   </Row>
    // </Col>
  )
}
